<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-overlay :value="overlay2" absolute opacity="0.8">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="Salvar">
                    <v-card-title class="primary white--text">
                        <span class="text-h5">Novo Usuário</span>
                    </v-card-title>
                    <v-card-text class="pt-4">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field label="Nome completo*" v-model="nome" :rules="ruleRequired" outlined
                                        dense clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-combobox :rules="ruleRequired" v-model="roleSelected" :items="roles"
                                        item-text="descricao" label="Perfil de Acesso*" item-value="descricao" outlined
                                        dense return-object></v-combobox>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field label="Email*" v-model="email" :rules="ruleEmailRequired" outlined
                                        dense clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field label="Telefone" v-model="telefone" outlined dense
                                        clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field label="Bilhete de Identidade" v-model="bilhete" outlined dense
                                        clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="10">
                                    <v-text-field :rules="passwordRules" v-model="password" label="Senha*" type="text"
                                        outlined dense required></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="2" class="d-flex align-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="mx-1" small fab dark color="red" v-on="on"
                                                @click="GeradorSenha()">
                                                <v-icon small dark>lock</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Gerar senha automática</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-container>
                        <small class="grey--text">*campos obrigatórios</small>
                    </v-card-text>
                    <v-card-actions class="px-6 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="fecharDialogo(false)">
                            Cancelar
                        </v-btn>
                        <v-btn color="primary" :disabled="!valid || !isPasswordValid" type="submit" depressed>
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import axios from "@/plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");

export default {
    data: () => ({
        dialog: true,
        overlay2: false,
        valid: true,
        showPassword: false,
        nome: "",
        roleSelected: null,
        email: "",
        password: "",
        telefone: "",
        bilhete: "",
        roles: [],
        ruleRequired: [(value) => !!value || "Campo obrigatório"],
        ruleEmailRequired: [
            (value) => !!value || "E-mail obrigatório",
            (value) => value.length <= 50 || "Máximo de 50 caracteres",
            (value) => {
                const pattern =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "E-mail inválido";
            },
        ],

        passwordRules: [
            v => !!v || 'Senha obrigatória',
            v => (v && v.length >= 8) || 'Mínimo 8 caracteres',
            v => /[A-Z]/.test(v) || 'Pelo menos uma letra maiúscula',
            v => /[a-z]/.test(v) || 'Pelo menos uma letra minúscula',
            v => /[0-9]/.test(v) || 'Pelo menos um número',
            v => /[^A-Za-z0-9]/.test(v) || 'Pelo menos um símbolo'
        ]
    }),

    computed: {
        userNivel() {
            return ls.get("nivel_user");
        },
        fkUsuario() {
            return ls.get("pkUsuario");
        },

        isPasswordValid() {
            if (!this.password) return false;
            return (
                this.password.length >= 8 &&
                /[A-Z]/.test(this.password) &&
                /[a-z]/.test(this.password) &&
                /[0-9]/.test(this.password) &&
                /[^A-Za-z0-9]/.test(this.password)
            );
        }
    },

    created() {
        this.InitializeRoles();
    },

    methods: {
        GeradorSenha() {
            var generator = require("generate-password");
            this.password = generator.generate({
                length: 8,
                numbers: true,
                lowercase: true,
                uppercase: true,
                symbols: true,
            });
            this.$refs.form.validate();
        },

        async InitializeRoles() {
            this.overlay2 = true;
            try {
                this.roles = await axios.get("/rolesFindAll").then((res) => res.data);
                if (this.userNivel) {
                    this.roles = this.roles.filter((r) => r.nivel >= this.userNivel);
                }
            } catch (error) {
                Swal.fire("Ocorreu um erro ao carregar os perfis", "", "error");
            } finally {
                this.overlay2 = false;
            }
        },

        async Salvar() {
            if (this.$refs.form.validate() && this.isPasswordValid) {
                this.overlay2 = true;
                try {
                    let crypto = require("crypto");
                    let password = crypto
                        .createHash("md5")
                        .update(String(this.password))
                        .digest("hex");

                    let params = {
                        pkUsuarioAutor: this.fkUsuario,
                        autor: ls.get("nomeUsuario"),
                        pkUsuario: 0,
                        nome: this.nome,
                        senha: password,
                        email: this.email,
                        telefone: this.telefone,
                        role: this.roleSelected.descricao !== undefined ? this.roleSelected.nome : this.roleSelected,
                        bi: this.bilhete,
                        enable: 1,
                    };

                    let result = await axios.post("/UsuarioOrUpdate", params);

                    if (result.status === 200) {
                        Swal.fire("Usuário registrado com sucesso", "", "success");
                        this.dialog = false;
                        this.fecharDialogo(true)
                    } else {
                        Swal.fire("Informação", "Email já existente na base de dados", "warning");
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire("Erro", "Ocorreu um erro ao cadastrar o usuário", "error");
                } finally {
                    this.overlay2 = false;
                }
            }
        },

        fecharDialogo(bool) {
            this.dialog = false;
            this.$emit('fecharComponente', bool)
        },
    },
};
</script>

<style scoped>
.v-card__title {
    padding: 16px 24px;
}

.v-card__actions {
    padding: 8px 16px;
}
</style>